// InvitationHandler.js
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

const InvitationHandler = () => {
  const { search } = useLocation();
  // Using loginWithRedirect (not signupWithRedirect)
  const { loginWithRedirect } = useAuth0();

  useEffect(() => {
    console.log("[InvitationHandler] Checking for org/invitation params.");
    const queryParams = new URLSearchParams(search);
    const invitation = queryParams.get('invitation');
    const organization = queryParams.get('organization');

    console.log("🔎 invitation param =", invitation);
    console.log("🔎 organization param =", organization);

    if (invitation && organization) {
      console.log("🚀 Found invitation & organization => redirecting to Auth0 with screen_hint=signup");
      // Use loginWithRedirect and set the appropriate authorizationParams
      // so that Auth0 recognizes an org-based sign-up.
      loginWithRedirect({
        authorizationParams: {
          screen_hint: 'signup',
          invitation: invitation,
          organization: organization,
          connection: "Username-Password-Authentication"
        }
      });
    }
  }, [search, loginWithRedirect]);

  // This component doesn't render anything
  return null;
};

export default InvitationHandler;
